<template>
    <div class="chatList" v-loading='loading' v-if="to_user">
        <div class="topuser">
            <div class="pic">
                <img :src="userdetail.show_avatar" alt="">
            </div>
            <div class="username">
                {{userdetail.show_name}}
            </div>
            <div class="sex">
                <img v-if="userdetail.patient_sex==1" src="../../../assets/imgs/nan.png" alt="">
                <img v-else src="../../../assets/imgs/nv.png" alt="">
            </div>
        </div>
        <div class="info_item">
            <span class="info_tit">年龄：</span><span class="info_text">{{userdetail.patient_age}}岁</span>
        </div>

        <div class="info_item">
            <span class="info_tit">价格：</span><span class="info_text">{{userdetail.commodity_current_price}}</span>
        </div>
        <div class="info_item">
            <span class="info_tit">咨询类型：</span><span class="info_text">{{userdetail.inquiry_type_text}}</span>
        </div>

        <div class="info_item">
            <span class="info_tit">创建时间：</span><span class="info_text">{{userdetail.create_time}}</span>
        </div>
        <div class="info_item">
            <span class="info_tit">接诊时间：</span><span class="info_text">{{userdetail.reception_time}}</span>
        </div>
        <div class="info_item">
            <span class="info_tit">咨询信息：</span><span class="info_text">{{userdetail.describe}}</span>
        </div>
        <div class="info_item">
            <span class="info_tit">咨询图片：</span>
            <div class="imgs_b">
                <div v-for="(img,index) in userdetail.file_info" :key="index" class="zximg">
                    <el-image style="width: 127px; height: 127px" :src="img.url" fit="cover" :preview-src-list="[img.url]"></el-image>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import {
        mapState
    } from 'vuex'

    export default {
        name: "chatList",
        props: ['to_user'],
        watch: {
            'to_user'(nVal, oVal) {}
        },
        data() {
            return {
                userdetail: '',
                loading: false,
                page: 0,
                curId: '',
                a: 1,
                // 总条数
                total: '',
                noMore: true,

            }
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            }),
        },
        mounted() {
        },
        created() {
            this.getList()
        },
        methods: {
            getList() {
                if (!this.to_user.id) {
                    return false
                }
                this.loading = true
                axios.post('/admin/pc/DoctorInquiry/read', {
                    id: this.to_user.id,
                    user: JSON.parse(sessionStorage.getItem('doc_data'))
                }, {
                    token: true
                }).then(res => {
                    this.userdetail = res.data.data
                    this.loading = false;
                }).catch((error) => {
                    console.log(error);
                    // this.loading = false;
                })
            },

            // 选择
            selectUser(item) {
                // let vue = this
                // vue.$parent.page = 1
                // this.curId = item.id
                // vue.$emit('setDataId', item)
            },
        },
        destroyed() {
            // this.bus.$off()
        }
    }
</script>

<style lang="scss" scoped>
    .chatList {
        // width: 100%;
        height: 742px;
        padding: 10px;
        border-right: 1px solid #ECECEC;

        .topuser {
            display: flex;
            align-items: center;
            margin-bottom: 20px;

            .pic {
                width: 50px;
                height: 50px;
                border-radius: 50%;
                overflow: hidden;

                img {
                    width: 100%;
                    display: block;
                }
            }

            .username {
                margin-left: 10px;
                font-size: 17px;
                font-weight: 600;
                margin-right: 5px;
            }

            .sex {
                width: 20px;

                img {
                    width: 100%;
                }
            }
        }

        .team_jj {
            padding: 0px 0 10px;

            .jj {
                font-size: 14px;

                .jj_tit {
                    font-size: 14px;
                    color: #999;
                }
            }
        }

        .team_hz {
            margin-top: 30px;
        }


        .team_user {
            .t_item {
                display: flex;
                align-items: center;
                padding: 5px 10px;

                .t_u_a {
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    overflow: hidden;

                    img {
                        width: 100%;
                        display: block;
                    }
                }

                .t_u_n {
                    margin-left: 10px;

                    .t_u_n_text_name {
                        font-size: 16px;
                    }

                    .t_u_n_text {
                        font-size: 12px;
                    }
                }
            }
        }

        .info_item {
            padding: 2px 0;

            .info_tit {
                font-size: 15px;
                color: #999;
            }

            +.info_text {
                font-size: 15px;
            }
            .imgs_b{
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                .zximg{
                    width: 50%;
                    img{
                        display: block;
                    }
                }
            }
        }

    }
</style>